/* eslint-disable @typescript-eslint/no-unused-vars */

import { TeamResponse } from 'lib/teams';
import DropDown, { DropDownOption } from 'components/common/DropDown';
import { ValueCallback } from 'types/callbacks';

type Props = {
  teams: TeamResponse[];
  selectedTeam: TeamResponse | undefined;
  selectTeam: ValueCallback<TeamResponse>;
};

export default function TeamSelection({
  teams,
  selectedTeam,
  selectTeam,
}: Props) {
  const onSelect = function (value: string | number) {
    const match = teams.find((team) => team.ownerId === value);
    if (match) {
      selectTeam(match);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        borderTop: '1px solid #444',
        borderBottom: '1px solid #444',
        padding: '12px 0',
      }}
    >
      <h4 style={{ margin: 0, color: 'white' }}>Save remix to:</h4>
      <DropDown
        displayValue={selectedTeam?.name || 'Select Workspace'}
        onSelect={onSelect}
        displayValueStyle={{ color: 'white', fontSize: '16px', marginLeft: 6 }}
        optionListStyle={{ left: '-7px', right: 'auto' }}
      >
        {teams.map((team) => (
          <DropDownOption
            value={team.ownerId}
            key={`team-${team.ownerId}`}
            selected={team.ownerId === selectedTeam?.ownerId}
            textAlign="left"
          >
            {team.name}
          </DropDownOption>
        ))}
      </DropDown>
    </div>
  );
}
